import { render, staticRenderFns } from "./CertificationTable.vue?vue&type=template&id=8ade0a76&scoped=true&"
import script from "./CertificationTable.vue?vue&type=script&lang=ts&"
export * from "./CertificationTable.vue?vue&type=script&lang=ts&"
import style0 from "./CertificationTable.vue?vue&type=style&index=0&id=8ade0a76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ade0a76",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VDataTable,VList,VListItem,VRow,VTextField})
